import Event from '@shared/classes/event';
import Plan from '@shared/classes/plan';
import Rail from '@shared/classes/rail';
import useAssetInfo from '@shared/components/utils/hooks/useAssetInfo';
import { createContext, MutableRefObject } from 'react';

const DetailContext = createContext<{
  animations?: {
    focusDetailContent: () => void;
    focusRelatedContent: () => void;
  } | null;
  callbacks?: {
    toggleFloatingMenu: (node: number | null) => void;
  };
  asset: Event | null;
  assetInfo: ReturnType<typeof useAssetInfo> | null;
  buttons?:
    | {
        title: string;
        action: () => void;
      }[]
    | null;
  complete: boolean;
  nextFocus?: {
    fromTop: MutableRefObject<null> | null;
    fromMiddle: MutableRefObject<null> | null;
    fromBottom: MutableRefObject<null> | null;
  } | null;
  refs?: {
    buttons: MutableRefObject<null>;
    synopsis: MutableRefObject<null>;
    related: MutableRefObject<null>;
  } | null;
  related?: Rail | null;
  synopsis?: string[] | null;
  upgradablePlan: Plan | null;
}>({
  animations: null,
  asset: null,
  assetInfo: null,
  buttons: null,
  complete: false,
  nextFocus: null,
  refs: null,
  related: null,
  synopsis: null,
  upgradablePlan: null,
});

export default DetailContext;
